import React from "react";
import { useHistory } from "react-router-dom";
import styled, { ThemeProvider } from "styled-components";
import { QueryParameters } from "@lifeat/shared/system/RouteConstants";
import { LifeAtButtonV2 } from "@common/LifeAtButtonV2/LifeAtButtonV2";
import { UpgradeCtaContextType } from "@contexts/CallToActionContext";
import ChevronLeftIcon from "@icons/ChevronLeftArrow.svg";
import { lightTheme } from "@themes/Theme";
import { RouteUtil } from "@util/index";
import PricingPageContent from "./PricingPageContent";

const PricingPageContainer = styled.div`
    height: 100dvh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: auto;
    background-color: ${(props) => props.theme.backgroundSecondary};
`;

const ControlStrip = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    width: 100%;
    height: auto;
    padding: 2px 4px;
`;

const StyledChevronLeftIcon = styled(ChevronLeftIcon)`
    fill: ${(props) => props.theme.iconColor};
`;

const BACK_BUTTON_LABEL = "Back";
interface PricingTierPageProps {}
export default function PricingPage(props: PricingTierPageProps) {
    const history = useHistory();
    const upgradeContext = (RouteUtil.getQueryParamValue(QueryParameters.UpgradeContext) ||
        "default") as UpgradeCtaContextType;

    return (
        <ThemeProvider theme={lightTheme}>
            <PricingPageContainer>
                <ControlStrip>
                    <LifeAtButtonV2 variant={"ghost"} disableHover={true} onClick={() => history.goBack()}>
                        <StyledChevronLeftIcon /> {BACK_BUTTON_LABEL}
                    </LifeAtButtonV2>
                </ControlStrip>
                <PricingPageContent upgradeContext={upgradeContext} />
            </PricingPageContainer>
        </ThemeProvider>
    );
}
